<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="510" >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="add">Создать интеграцию {{type === 'CrmCallsCC' ? 'CRMCalls CC' : type}}</div>
      </template>
      <div @click="close" class="close">
        <Icon name="close"/>
      </div>
      <v-card class="wrapper">
      
        <TelegramForm v-if="type == 'Telegram'" :update="updateData" :pre_data="pre_data"/>
        <TildaForm v-if="type=='Tilda'" :update="updateData" :pre_data="pre_data"/>
        <WebHook v-if="type=='Webhook'" :update="updateData" :pre_data="pre_data"/>
        <SMSGateForm v-if="type === 'SMSGate'" :update="updateData" :pre_data="pre_data" />
        <CrmCallsCCForm v-if="type === 'CrmCallsCC' && dialog" :update="updateData" :pre_data="pre_data" />
        <div v-if="error" class="form-error" role="alert">{{ error }}</div>
          
      <div class="add btn_save" @click="save">Сохранить</div>
      <div class="cancel cancel_btn" @click="close">Отменить</div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import Icon from '../../SetIcon.vue'
import TelegramForm from './Form/TelegramForm.vue'
import TildaForm from './Form/TildaForm.vue'
import WebHook from './Form/WebHook.vue'
import SMSGateForm from './Form/SMSGateForm.vue'
import CrmCallsCCForm from './Form/CrmCallsCCForm.vue'
export default {
  props: ['callback_refresh','data','show_dialog','type'],
  components: {
    Icon,
    TelegramForm,
    TildaForm,
    WebHook,
    SMSGateForm,
    CrmCallsCCForm
  },
  watch: {
    dialog(val) {
      if (!val && this.type === 'CrmCallsCC') {
        this.id = false
        this.pre_data = false
        this.save_data = false
        this.error = ''
      }
    },
    show_dialog: function (val) {
      
      if (val)
      {
        this.id=this.data.id
        this.pre_data=this.data.item   
        this.save_data=this.data.item   
      }
      this.dialog=val
    },
  },
  data(){
    return {
      dialog: false,
      id:false,
      save_data:false,
      pre_data:false,
      error: '',
      tab: 'manual',
    
    }
  },
  methods: {
  close(norender=true)
  {
      this.error = ''
      this.id=false
      this.pre_data=false
      this.save_data=false
      this.dialog=false
      this.callback_refresh(norender)
  },
  updateData(save)
  {
    this.save_data=save
  },
   save()
   {
     this.error = ''
     if (this.type === 'CrmCallsCC') {
       if (!this.save_data || !String(this.save_data.name || '').trim()) {
         this.error = 'Укажите название интеграции'
         return
       }
       if (!this.id && !String(this.save_data.api_token || '').trim()) {
         this.error = 'Укажите API-токен CRMCalls CC'
         return
       }
     }
     if (this.save_data)
     {
       this.$http.post("/integrations/add",
       {
         type:this.type,
         id: this.id,
         save:this.save_data
       },(data)=>{
         if (this.type === 'CrmCallsCC' && data !== true) {
           this.error = (data && data.message) || 'Не удалось сохранить интеграцию'
           return
         }
         if (data)
         {
           this.close(false)
         }
         
       })
     }
     
   }
 }
}
</script>
<style scoped>
.form-error { margin: 0 0 16px; color: #de4040; font-size: 14px; }
.cancel{
  color: #4B5EFF;
}
.subtitle{
  font-style: normal;
  text-align: left;
  font-weight: 700;
  font-size: 17px;
  line-height: 120%;
  color: #404247;
}
.wrapper{
  padding: 32px;
}
.modal_subtitle{
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  margin-bottom: 6px;
  text-align: left;
  color: #404247;
}
.add{
  border: none;
  padding: 12px 20px 12px 22px;
  background: #4B5EFF!important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: center;
  color: #eee;
  cursor: pointer;
}
.add .icon{
  margin-right: 11px;
}
.modal_title{
  padding: 0!important;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  margin-bottom: 24px;
  text-align: center;
  line-height: 130%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #2B2D33;
}
</style>
